export interface MapProvider {
  id: string;
  name: string;
  url: string;
  attribution: string;
  maxZoom?: number;
}
export const osm: MapProvider = {
  id: 'osm',
  name: 'OpenStreetMap',
  url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
  attribution:
    '© <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors',
  maxZoom: 19,
};
// Open LGL WMTS, EPSG:3857 matrix. This grid name does not imply Google imagery.
export const aerial: MapProvider = {
  id: 'lgl-dop20',
  name: 'Luftbild · LGL Baden-Württemberg',
  url: 'https://owsproxy.lgl-bw.de/owsproxy/ows/WMTS_LGL-BW_ATKIS_DOP_20_C?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=DOP_20_C&STYLE=default&FORMAT=image/jpeg&TILEMATRIXSET=GoogleMapsCompatible&TILEMATRIX=GoogleMapsCompatible:{z}&TILEROW={y}&TILECOL={x}',
  attribution:
    'Datenquelle: <a href="https://www.lgl-bw.de/Produkte/Open-Data/" target="_blank" rel="noopener">LGL, www.lgl-bw.de</a>, <a href="https://www.govdata.de/dl-de/by-2-0" target="_blank" rel="noopener">dl-de/by-2-0</a>',
  maxZoom: 19,
};
export type MapMode = 'aerial' | 'street';
